import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Rfc} from "../../models/request";
import {API_ENDPOINTS} from "./api.constants";
import {ENV} from "../../app/app.env";
import {VendorUpdate} from "../../models/update";

@Injectable()
export class ApiProvider
{

    constructor(public http: HttpClient)
    {
        console.log('Hello ApiProvider Provider');
    }

    public getOfflineMode()
    {
        let url = `${ENV.API_URL}${API_ENDPOINTS.GET_OFFLINE_MODE}`;
        return this.http.get(url,  { headers: ['ocp-apim-subscription-key', 'a085f08977ec40cc8731649956d9e1eb']}).toPromise();
    }

    /**
     * Contacts the api to get an rfc by id
     * @param id
     * @returns {Observable<Object>}
     */
    public getRequestById(id: any)
    {
        let url = `${ENV.API_URL}${API_ENDPOINTS.GET_RFC_BY_ID}${id}`;
        return this.http.get<Rfc>(url,  { headers: ['ocp-apim-subscription-key', 'a085f08977ec40cc8731649956d9e1eb']});
    }

    /**
     * Contacts the api to update and RFC
     * @param {Update} update
     * @returns {Observable<Object>}
     */
    public updateRfc(update: VendorUpdate)
    {
        let url = `${ENV.API_URL}${API_ENDPOINTS.VENDOR_UPDATE_RFC}`;
        let updateJson = JSON.stringify(update);
        return this.http.post(url, updateJson, {headers: this.getPostOptions()});
    }

    private handleErrors(err: HttpErrorResponse)
    {
        if (err.error instanceof Error)
        {
            // A client-side or network error occurred. Handle it accordingly.
            console.log('An error occurred:', err.error.message);
        }
        else
        {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
    }

    /**
     * @description Returns default post options
     * @returns {HttpHeaders}
     */
    private getPostOptions(): HttpHeaders
    {
        return new HttpHeaders().set('Content-Type', 'application/json');
    }

}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts